import React, { useEffect, useState } from "react";
import logoigtwhiteslice from "../../assets/logoigt_white_slice.png";
import profileImg from "../../assets/profile_img.jpg";
import * as CryptoJS from "crypto-js";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";

import "../../css/header.css";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../features/user/userSlice";
import { useNavigate } from "react-router-dom";
import { postRequest } from "services/api";

const Header = () => {
  const dispatch = useDispatch();
  const [avatarOption, setAvatarOption] = useState(null);
  const { userSetting, user } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [curPass, setCurPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [loading, setLoading] = useState(false); 

  const handleOpenMenu = (event, setAnchorEl) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAvatarOption(null);
  };

  const openPasswordDialog = () => {
    handleCloseMenu();
    setOpenChangePassword(true);
  };

  const closePasswordDialog = () => {
    setOpenChangePassword(false);
    setCurPass("");
    setNewPass("");
    setConfirmPass("");
  };

  const handleChangePasswordSubmit = async () => {
    if (!curPass || !newPass || !confirmPass) {
      alert("Please fill all fields");
      return;
    }

    if (newPass !== confirmPass) {
      alert("New password and confirm password do not match");
      return;
    }

    try {
      setLoading(true);
      const key = CryptoJS.enc.Utf8.parse("bwplAPVp1OH7Xzyr");
      
      const iv = CryptoJS.enc.Utf8.parse("bwplAPVp1OH7Xzyr");

      const encryptedCurrPwd = CryptoJS.AES.encrypt(curPass, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      const encryptedNewPwd = CryptoJS.AES.encrypt(newPass, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      let headers = {
        "Content-Type": "application/json;",
        Authorization: `Bearer ${user?.token}`,
      };
      const payload = {
        uid: user?.Id,
        curPass: encryptedCurrPwd.toString(),
        newPass: encryptedNewPwd.toString()
      };

      const response = await postRequest("user/ChangePswd",payload,headers);

      if (response.data?.Status === 1) {
        alert("Password changed successfully. Please login again.");

        closePasswordDialog();

        // Recommended after password change
        //handleLogout();
      } else {
        alert(response.data?.Message || "Password change failed");
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong while changing password");
    } finally {
      setLoading(false);
    }
  };

  const handleSidebar = () => {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login", { replace: true });
  };

  const handleChangePassword = () => {
    openPasswordDialog(true)
  };

  useEffect(() => {
    if (!localStorage.getItem("userCredential")) {
      navigate("/login");
    }
  }, [user]);

  if (!user) {
    return null;
  }

  return (
    <header id="page-topbar">
      <div className="navbar-headers">
        <div className="left-header">
          <div className="navbar-brand-box">
            <a className="logo" href="/">
              <span className="logo-sm">
                <img src={logoigtwhiteslice} alt="" height="32" />
              </span>
            </a>
          </div>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={handleSidebar}
          >
            <MenuIcon />
          </IconButton>
          <div className="customerName">
            {user?.userType !== "Admin"
              ? userSetting?.[0]?.currCustomer
              : "Igd Admin"}
          </div>
        </div>
        <div className="right=header">
          <IconButton
            onClick={(e) => handleOpenMenu(e, setAvatarOption)}
            sx={{
              ml: 1,
              "&.MuiButtonBase-root:hover": {
                bgcolor: "transparent",
              },
            }}
          >
            <Box sx={{ fontSize: "16px", marginRight: "10px" }}>
              {user?.Email}
            </Box>
            <Avatar alt="Remy Sharp" src={""} />
          </IconButton>
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={avatarOption}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(avatarOption)}
            onClose={handleCloseMenu}
          >
            <MenuItem onClick={handleChangePassword}>
              <Typography sx={{ textAlign: "center" }}>
                Change Password
              </Typography>
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <Typography sx={{ textAlign: "center" }}>Logout</Typography>
            </MenuItem>
            
          </Menu>
        </div>
        <Dialog
          open={openChangePassword}
          onClose={closePasswordDialog}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle>Change Password</DialogTitle>

          <DialogContent>
            <TextField
              fullWidth
              margin="dense"
              label="Current Password"
              type="password"
              value={curPass}
              onChange={(e) => setCurPass(e.target.value)}
            />

            <TextField
              fullWidth
              margin="dense"
              label="New Password"
              type="password"
              value={newPass}
              onChange={(e) => setNewPass(e.target.value)}
            />

            <TextField
              fullWidth
              margin="dense"
              label="Confirm New Password"
              type="password"
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={closePasswordDialog} disabled={loading}>
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleChangePasswordSubmit}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Password"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </header>
  );
};

export default Header;
